const initialState = {
	isLoading: false,
	isLoading_shop_product: false,
	listpromotionv2: [],
	totalsize: 0,
	listpromotionv2shopsproducts: [],
	totalsize_shopsproducts: 0
};

function promotionv2Reducer(state = initialState, action) {
    switch (action.type) {
		case 'LOADING_PROMOTIONV2':
			return {
				...state,
				isLoading: action?.payload
			};
		case 'LOADING_PROMOTIONV2_SHOP_PRODUCT':
			return {
				...state,
				isLoading_shop_product: action?.payload
			};
		case 'LIST_PROMOTIONV2':
			return {
				...state,
				listpromotionv2: action?.payload?.listpromotionv2 || [],
				totalsize: action?.payload?.totalsize || 0
			};
		case 'LIST_PROMOTIONV2_SHOP_PRODUCT':
			return {
				...state,
				listpromotionv2shopsproducts: action?.payload?.listpromotionv2shopsproducts || [],
				totalsize_shopsproducts: action?.payload?.totalsize_shopsproducts || 0
			};
		default:
		  return state;
    }
}

export default promotionv2Reducer;
